module.exports = __webpack_public_path__ + "static/media/binance.e0e0e44b.svg";